import { ReactComponent as CopyIcon } from './svg/copyIcon.svg'

export default CopyIcon
